exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nh2[data-v-4a2b83b8] {\n    border-bottom: 1px solid #eee;\n    margin-bottom: 10px;\n}\n.reload-button[data-v-4a2b83b8] {\n    margin-left: -2px;\n}\nul[data-v-4a2b83b8] {\n    margin-bottom: 10px;\n}\n", ""]);

